import { Faq } from '@aibees/shared/features/price-and-plan/components/faq';
import { PricingHeader } from '@aibees/shared/features/price-and-plan/components/pricing-header';
import { type MouseEventHandler, useRef } from 'react';
import { ClientsComments } from './components/clients-comments';
import { PlanDetail } from './components/plan-detail';
import * as Styled from './styles';

export function PriceAndPlan() {
  const comparisonRef = useRef<any>();

  const handleScrollToComparison: MouseEventHandler<HTMLDivElement> = (e) => {
    if (
      comparisonRef &&
      comparisonRef.current &&
      (e.target as any).getAttribute('rel')
    ) {
      comparisonRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Styled.Wrapper onClick={handleScrollToComparison}>
        <PricingHeader />
        <PlanDetail />
        <ClientsComments />
      </Styled.Wrapper>
      <Faq />
    </>
  );
}
